const getCurrentUrlWithoutPortalId = () => window.location.href.replace(/[0-9]/g, '');
export default getCurrentUrlWithoutPortalId;